export default __webpack_public_path__ + "img/profile.056db542.jpg";